export default {
  walking: "#3DD295",
  car: "#FF8700",
  bus: "#0073FE",
  public_bus: "#0073FE",
  "public bus": "#0073FE",
  taxi: "#FDC09B",
  train: "#AC74D6",
  bicycling: "#B6F8F3",
  carpool: "#FBDE05",
  "school bus": "#00CAFF",
  school_bus: "#00CAFF",
  unknown: "red",
  still: "black",
};
